import React, {Suspense, useState} from 'react';
import {Link} from "react-router-dom";
import {Outlet, useLocation} from "react-router-dom";
import Navbar from '../components/navbar/Navbar';
import HeaderCtaAds from '../components/HeaderCtaAds';
import Footer from '../components/Footer';
import Disclaimer from "../pages/disclaimer/Disclaimer";
import createLink from "../../libs/createLink";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Authenticated from "../../libs/Authenticated";
import {Button} from "../components/Button";
import EmailValidation from "../components/SignUpInformation/components/EmailValidation";
import _ from "lodash";
import Cookies from 'universal-cookie';
import {isBot} from "../../libs/helper";
import {LoadingSuspense} from "../components/Loader";
import AnnouncementMessage from "../components2/announcementMessage/AnnouncementMessage";
import {useQuery} from "@tanstack/react-query";
import {USER_CURRENT_CLICK_CTA_KEY} from "../../api/public-voissa/users";
import useToken from "../../hooks/token";
import fnClickCta from "../../libs/clickCta";
import useCurrentUser from "../../queries/currentUser";
import AgeConfirmed from "../components/ageConfirmed/AgeConfirmed";


const cookies = new Cookies();


const Main = () =>{

    const location = useLocation();
    const [token] = useToken();

    const [hasAcceptedDisclaimer, setHasAcceptedDisclaimer] = useState(isBot || cookies.get('DISCLAIMED') || token || false)
    const [toggleModalEmailUnconfirmed, setToggleModalEmailUnconfirmed] = useState(false);

    if(window.location.hash.match(/[#&](nodisclaimer)/)){
        cookies.set('DISCLAIMED', 'accepted',{expire:0});
        let hash = window.location.hash.replace(/(.*)[#&]nodisclaimer(.*)/, '$1$2');
        if(hash !== ""){
            if(hash.substr(0,1) === "&"){
                hash = hash.substr(1,hash.length);
            }
            if(hash.substr(0,1) !== "#"){
                hash = `#${hash}`;
            }
        }
        let newUri = window.location.pathname + window.location.search + hash;
        window.history.replaceState({}, document.title, newUri);
        setHasAcceptedDisclaimer(true);
    }



    const {isSuccess : isSuccessCurrentUser,data : dataCurrentUser} = useCurrentUser({enabled : !!token});


    let currentUser = dataCurrentUser || {};
    let initUser = (!token || (isSuccessCurrentUser && !!token));

    useQuery(
        [USER_CURRENT_CLICK_CTA_KEY],
        ()=> fnClickCta(currentUser),
        {
            staleTime : ( 1000 * 60 * 2),
            enabled : !!_.get(currentUser,'_id'),
            placeholderData : fnClickCta(currentUser),
            //notifyOnChangeProps : ['data'],
        }
    );

    let showHeaderCtaAds = (location.pathname === '/');// ([createLink("messenger"), '/user', '/User', createLink("actuality"), '/user-albums', '/gallery-album', '/user-informations', '/user-articles', createLink("signin"), createLink("signup"), createLink("dating"), '/forgot-password', '/404'].indexOf(this.props.location.pathname) === -1);
    let showHeaderBgHeart = ([createLink("messenger"), '/user', '/User', createLink("actuality"), '/user-albums', '/gallery-album', '/user-informations', '/user-articles', createLink("dating"), '/moderation'].indexOf(location.pathname) === -1);
    let showHotContent = ([createLink("messenger")].indexOf(location.pathname) === -1 && !RegExp('/mediaviewer/*').test(location.pathname));
    let showOnlyView = ([createLink("signin"), createLink("signup")].indexOf(location.pathname) === -1);

    return (
        <main className={`${showHeaderBgHeart && showHeaderCtaAds ? 'bgHeart' : ''} ${!showOnlyView ? 'bgHeart' : ''}`}>

            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                closeOnClick
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />
            <Disclaimer handleBlur={()=> setHasAcceptedDisclaimer(true)} hasAcceptedDisclaimer={hasAcceptedDisclaimer}/>
            {initUser ? <Navbar initUser={initUser} /> : null}

            {initUser && !RegExp(`${createLink("messenger")}/*`).test(location.pathname) &&
                !RegExp(`chat-webcam`).test(location.pathname) &&
                <AnnouncementMessage role={_.get(currentUser,"role") || "guest"} />}

            {!RegExp(`/first-connexion`).test(location.pathname) && !RegExp(`/mon-profil/parametres/*`).test(location.pathname) ?  <AgeConfirmed /> : null}

            <Authenticated passThrough>
                {(authenticated) => {
                    return !authenticated && location.pathname !== "/page-introuvable" ? (
                        showHeaderCtaAds && !token && <HeaderCtaAds/>
                    ) : location.pathname === createLink("signin") || location.pathname === createLink("signup") || location.pathname === createLink("dating") || location.pathname === createLink("forgotPassword") ? (
                        ''
                    ) : ''
                }}
            </Authenticated>
            {
                !location.pathname.includes('first-connexion') && _.get(currentUser, "email.bounced")
                    ? (
                        <div className="alert-bar">
                            <span className="alert-bar-message">Votre adresse email semble invalide, <Link
                                to={createLink("userMeSettingsEmailAndPassword")}>cliquez ici pour la modifier.</Link></span>
                        </div>
                    )
                    : null
            }
            {!location.pathname.includes('first-connexion') && _.get(currentUser,"role") === "emailUnconfirmed"
                ? (
                    <div className="alert-bar" onClick={() => setToggleModalEmailUnconfirmed(true)}>
                        <span className="alert-bar-message">
                            Merci de confirmer votre email afin de pouvoir utiliser toutes les
                        fonctionnalités du site
                        </span>
                        <Button className="danger"
                                size={"small"}
                                content="Confirmer"/>
                    </div>
                ) : null}

            {isSuccessCurrentUser ? (
                <EmailValidation
                    toggle={toggleModalEmailUnconfirmed}
                    handleClose={() => setToggleModalEmailUnconfirmed(false)}
                    isModal={true}
                    avatar={_.get(currentUser, 'profile.avatar')}
                    gender={_.get(currentUser, 'profile.gender')}
                    email={_.get(currentUser, 'email.address')}/>
            ) : null}

            <div id="view" >
                {initUser ? (
                    <Suspense fallback={<LoadingSuspense />}>
                        <Outlet context={{currentUser, isSuccessCurrentUser}} />
                    </Suspense>
                ) : (
                    <LoadingSuspense />
                )}

            </div>

            {!RegExp(`${createLink("messenger")}/*`).test(location.pathname) &&
                !RegExp(`xxx-photos/*`).test(location.pathname) &&
                !RegExp(`xxx-videos/*`).test(location.pathname) &&
                !RegExp(`chat-webcam`).test(location.pathname) &&
                showHotContent && showOnlyView && location.pathname !== createLink("actuality") &&
                <Footer />}
        </main>
    )
}

export default Main;